import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authSlice from './authSlice';
import vehiclesSlice from './vehiclesSlice';
import alertsSlice from './alertsSlice';
import parkingSlice from './parkingSlice';
import maintenanceSlice from './maintenanceSlice';
import vehicleConditionAssessmentSlice from './vehicleConditionAssessmentSlice';
import conditionNoteTypeSlice from './conditionNoteTypeSlice';
import conditionPhotoTypeSlice from './conditionPhotoTypeSlice';
import pricingSlice from './pricingSlice';
import prestationSlice from './prestationSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    vehicles: vehiclesSlice,
    alerts: alertsSlice,
    parking: parkingSlice,
    maintenance: maintenanceSlice,
    vehicleConditionAssessments: vehicleConditionAssessmentSlice,
    conditionNoteTypes: conditionNoteTypeSlice,
    conditionPhotoTypes: conditionPhotoTypeSlice,
    pricing: pricingSlice,
    prestation: prestationSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector; 